import NetxQueryClient, {
	type SuccessResponse,
} from '@netx/core-next/lib/queryClient';
export type {QueryError} from '@netx/core-next/lib/queryClient';
import {getResponseResults} from '@netx/core-next/utils/api';

export type ReplaceAttributeVocabularyWithFileRequestOptions = {
	fileName: string;
	vocabId: number;
};

/**
 * `replaceAttributeVocabularyWithFile` request
 * (what gets sent to the server)
 */
export type ReplaceAttributeVocabularyWithFileRequest = [
	ReplaceAttributeVocabularyWithFileRequestOptions['vocabId'],
	ReplaceAttributeVocabularyWithFileRequestOptions['fileName'],
];

/**
 * `replaceAttributeVocabularyWithFile` response
 * (what comes back from the server)
 */
export type ReplaceAttributeVocabularyWithFileResponse =
	SuccessResponse<ReplaceAttributeVocabularyWithFileResult>;

/**
 * `replaceAttributeVocabularyWithFile` result
 * (what is utilized from the server response)
 */
export type ReplaceAttributeVocabularyWithFileResult = string; // uuid

export const replaceAttributeVocabularyWithFileEndpoint =
	'replaceAttributeVocabularyWithFile';

/**
 * Process uploaded vocab file
 * @param fetchParams Fetch params
 */
export const replaceAttributeVocabularyWithFile = async ({
	fileName,
	vocabId,
}: ReplaceAttributeVocabularyWithFileRequestOptions) => {
	const client = NetxQueryClient();

	const requestParams: ReplaceAttributeVocabularyWithFileRequest = [
		vocabId,
		fileName,
	];

	return client
		.post<ReplaceAttributeVocabularyWithFileResponse>(
			replaceAttributeVocabularyWithFileEndpoint,
			requestParams,
		)
		.then(getResponseResults);
};

export default replaceAttributeVocabularyWithFile;
